'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('../../../style/');

var _CircularProgress = require('material-ui/CircularProgress');

var _CircularProgress2 = _interopRequireDefault(_CircularProgress);

var _util = require('@its/util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var loadingStyle = (0, _util.merge)(_style.center, { margin: '0 !important' });

var overlay = {
  position: 'absolute',
  height: '100%',
  bottom: '0',
  right: '0',
  left: '0',
  zIndex: '5000',
  backgroundColor: 'white'
};

var _class = function (_React$Component) {
  _inherits(_class, _React$Component);

  function _class(props, context) {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props, context));

    _this.previousState = props.visible;
    _this.scrollEnabled = !props.visible;
    return _this;
  }

  _createClass(_class, [{
    key: 'render',
    value: function render() {
      var visible = this.props.visible;

      if (visible !== this.previousState) {
        this.previousState = visible;
        if (this.scrollEnabled) {
          window.scrollTo(0, 0);
          (0, _util.disableScroll)();
          this.scrollEnabled = false;
        } else {
          (0, _util.enableScroll)();
          this.scrollEnabled = true;
        }
      }
      return visible ? _react2.default.createElement(
        'div',
        { style: this.props.overlay ? overlay : null },
        _react2.default.createElement(_CircularProgress2.default, { style: loadingStyle })
      ) : _react2.default.createElement(
        'div',
        null,
        this.props.children
      );
    }
  }]);

  return _class;
}(_react2.default.Component);

_class.propTypes = {
  children: _react2.default.PropTypes.any,
  visible: _react2.default.PropTypes.bool,
  overlay: _react2.default.PropTypes.bool
};
_class.defaultProps = {
  visible: true,
  overlay: false
};
exports.default = _class;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Presentational components/Pages/Loading/Loading.js
 ** module id = 176
 ** module chunks = 0
 **/